import { useTranslation } from "react-i18next";

export function FreeTextCondition({
  label,
  text,
}: {
  label: "diagnosis" | "symptom";
  text: string;
}) {
  const { t } = useTranslation();
  return (
    <div className="rounded-md border bg-white p-3">
      <div className="text-sm font-medium text-gray-600">{t(label)}</div>
      <div className="whitespace-pre-wrap break-words text-gray-900">
        {text}
      </div>
    </div>
  );
}
